export default {
  methods: {
    async loading(f) {
      const loading = document.getElementById("loading");
      try {
        loading.style.display = "flex";
        await f();
        loading.style.display = "none";
      } catch (error) {
        loading.style.display = "none";
      }
    },
  },
};
